import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OTPVerificationformComponent } from './otp-verification.component';
import { NgxOtpInputModule } from 'ngx-otp-input';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@NgModule({
  declarations: [OTPVerificationformComponent],
  imports: [CommonModule, NgxOtpInputModule, TranslateModule],
  exports: [OTPVerificationformComponent],
  providers: [
    LocalizationService,
    TranslateModule
  ],
})
export class OtpVerificationModule {}
